import React, { Fragment, useState, useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Grid, Paper, Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import { getLivePostsGroupCount } from '../../actions/admin/analyticsAction';
import { getCategoriesUnderGroup } from '../../actions/admin/category';
import CategoryCard from './categoryCard';
import OverLoading from '../global/OverLoading';
import AnalyticsSelection from './AnalyticsSelection/AnalyticsSelection';

const CategoryAnalytics = ({ getLivePostsGroupCount, getCategoriesUnderGroup }) => {
  const [loaded, setLoaded] = useState(false);
  const [allCategoryGroups, setAllCategoryGroups] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [categoryCards, setCategoryCards] = useState([]);

  /* Fetch Category Group and Total Count */
  const fetchCategoryGroups = async () => {
    try {
      const params = {
        type: 'group',
      };
      const categoryGroups = await getLivePostsGroupCount(params);
      if (categoryGroups) {
        setAllCategoryGroups(categoryGroups);
      }
    } catch (err) {
      toast.error(err);
    }
  };

  /* Fetch Individual Category and Total Count */
  const fetchCategories = async () => {
    const params = {
      type: 'name',
    };
    const categories = await getLivePostsGroupCount(params);
    if (categories) {
      setAllCategories(categories);
    }
  };

  useEffect(() => {
    fetchCategoryGroups();
    fetchCategories();
  }, []);

  /* Fetch Category Names under Each Group */
  const assignCategories = async (group) => {
    let response = [];
    await getCategoriesUnderGroup({ categoryGroup: group }).then((result) => {
      response = [...result];
    });
    return response;
  };

  useEffect(() => {
    let counter = 0;
    const cardsArray = [];
    for (const group of allCategoryGroups) {
      assignCategories(group.categoryGroup).then((result) => {
        /* Reassign All Categories to Each Individual Group */
        const set = new Set();
        const list = [];
        result.forEach((category) => set.add(category.name));

        allCategories.forEach((category) => {
          if (set.has(category.categoryGroup)) {
            list.push(category);
          }
        });

        /* Push Each Category Card into the Array */
        cardsArray.push(
          <CategoryCard
            cardTitle="Category Group"
            categoryGroup={group.categoryGroup}
            totalCount={group.totalCount}
            categories={list}
          />,
        );
        setCategoryCards([...cardsArray]);
      });
      counter += 1;

      if (counter === allCategoryGroups.length) {
        setLoaded(true);
      }
    }
  }, [allCategoryGroups, allCategories]);

  const renderCategoryCards = () => {
    const card = categoryCards.map((catCard) => (
      <Grid
        item
        key={catCard.props.categoryGroup}
        style={{ padding: 15 }}
      >
        {catCard}
      </Grid>
    ));
    return card;
  };

  return (
    <div>
      <>
        <div className="content-header">
          <h1>Analytics</h1>
        </div>
      </>
      { loaded ? (
        <>
          <Grid container>
            <Grid item style={{ padding: 15 }}>
              <Paper variant="outlined" style={{ padding: 20 }}>
                <Typography variant="subtitle2">Live Promotional Posts</Typography>
              </Paper>
            </Grid>
          </Grid>
          <Grid container>
            {renderCategoryCards()}
          </Grid>
          <div className="">
            <AnalyticsSelection />
          </div>
        </>
      ) : <OverLoading /> }
    </div>
  );
};

export default connect(null, { getLivePostsGroupCount, getCategoriesUnderGroup })(CategoryAnalytics);
